export const SEA_PRODUCT = [
  {
    order: true,
    id: 107799995137,
    title: "Маска для ныряния",
    img: "diving-mask-100-grey-subea-8491466.jpg",
    desc: "GRI100 S",
    category: "mask",
    price: 55,
    column: [
      "Измеренный внутренний объем: 183 см³",
      "Тканевый ремешок не дергает волосы. Встроенный держатель для трубки.",
    ],
  },
  {
    order: true,
    id: 10779999435137,
    title: "Маска для ныряния",
    img: "diving-mask-100-grey-subea-8491466.jpg",
    desc: "GRI100 M, L",
    category: "mask",
    price: 65,
    column: [
      "Измеренный внутренний объем: 183 см³",
      "Тканевый ремешок не дергает волосы. Встроенный держатель для трубки.",
    ],
  },
  {
    order: true,
    id: 10779909035137,
    title: "Маска для ныряния",
    img: "021f8f66-6850-43a1-85a5-9717095d2bcb.webp",
    desc: "JUNHAIINS",
    category: "mask",
    price: 60,
    column: [
      "Маска для сноркелинга JUNHAIINS — герметичная, не запотевающая силиконовая маска с широким обзором 180°. Обеспечивает комфортную посадку и отличную видимость под водой. Подходит для мужчин и женщин.",
    ],
  },
  {
    order: true,
    id: 107799099891370,
    title: "Маска закрытая",
    img: "easybreath-540-freetalk.png",
    desc: "SUBEA Haki М/L",
    category: "mask",
    price: 130,
    column: [
      "Полнолицевая маска, обеспечивающая естественное дыхание через нос и/или рот.",
      "Акустический клапан позволяет общаться вне воды, не снимая маски.",
      "Специальная система циркуляции воздуха предотвращает образование тумана.",
      "Трубка с функцией сухого сброса сверху предотвращает попадание воды и засорение клапана",
      "Панорамное поле зрения, эффективное до 180°",
    ],
  },
  {
    order: true,
    id: 1077990998913704,
    title: "Трубка для ныряния",
    img: "cover535.png",
    desc: "взрослая SUBEA 100",
    category: "mask",
    price: 40,
    column: [
      "Трубка для подводного спорта с высоким потоком воздуха.",
      "Большой диаметр обеспечивает лёгкое дыхание между погружениями.",
      "Силиконовый ортодонтический загубник для комфортного использования.",
      "Полужёсткая конструкция — удобно складывается и помещается в карман.",
      "Позволяет эффективно контролировать выброс воды при всплытии.",
    ],
  },
  {
    order: true,
    id: 10909891370,
    title: "Силиконовая маска",
    img: "6d8acb8a-c826.png",
    desc: "для снорклинга",
    category: "mask",
    price: 120,
    column: [
      "Полнолицевая силиконовая маска для сноркелинга — водонепроницаемая маска с большой панорамной рамкой, защитой от запотевания и держателем для камеры. Обеспечивает широкий обзор и комфортное дыхание. Идеальна для взрослых.",
    ],
  },

  {
    order: true,
    id: 999009081370,
    title: "Очки для плавания",
    img: "swimming-goggles-ready-one-size-clear-lenses-grey-nabaiji-8616684.jpg",
    desc: "NABAIJI серые",
    category: "mask",
    price: 30,
    column: [
      "Плавайте с ясным обзором благодаря специальной противотуманной обработке.",
      "Отличная фиксация очков для комфортного плавания.",
      "Очки обеспечивают хорошее поле зрения.",
      "Линзы фильтруют более 99% вредных UVA- и UVB-лучей, защищая ваши глаза.",
    ],
  },
  {
    order: true,
    id: 99944998913730,
    title: "Очки для плавания",
    img: "xbase-100-adult-swimming-goggles-clear-lenses-black-nabaiji-8669830.avif",
    desc: "NABAIJI (черные, голубые, розовые) ",
    category: "mask",
    price: 35,
    column: [
      "Благодаря специальной обработке эти очки не запотевают во время плавания.",
      "У вас будет замечательный обзор 120° – 140°",
      "Отличная фиксация благодаря небольшим линзам",
      "Отрегулируйте носовую перемычку (S,M,L) и ремешок с отметками и клипсой",
      "Попадание воды внутрь ограничено мягким прилегающим корпусом.",
    ],
  },
  {
    order: true,
    id: 9994499891398730,
    title: "плавательные очки",
    img: "fa8b.png",
    desc: "Противотуманные силиконовые",
    category: "mask",
    price: 45,
    column: [
      "Стильные противотуманные силиконовые плавательные очки с HD-ясностью — водонепроницаемые очки с регулируемым ремешком, чёрной оправой, подходят для мужчин и женщин.",
      "Идеальны для тренировок и водных видов спорта.",
    ],
  },
  {
    order: true,
    id: 3092439876730,
    title: "Детские очки",
    img: "e00ba9e4-ba61-4990-a272-51e358b1ccdb.webp",
    desc: "плавательные",
    category: "mask",
    price: 24,
    column: [
      "Детские плавательные очки для детей 3–12 лет — обеспечивают защиту от запотевания, чёткое зрение и надёжную герметичность.",
      "Оснащены быстро регулируемым ремешком для удобной посадки.",
    ],
  },
  {
    order: true,
    id: 140909891370,
    title: "чехол для маски",
    img: "72092b3b-c785-460e-875f-69e816.png",
    desc: "Водонепроницаемый",
    category: "mask",
    price: 25,
    column: [
      "Портативный чехол для хранения маски для дайвинга и подводного плавания.",
      "Прочный материал: EVA — надёжно защищает от повреждений.",
      "Большой размер — подходит для большинства моделей масок.",
      "Оснащён застёжкой-молнией для удобного открывания и закрывания.",
      "Универсален — подходит для мужчин и женщин.",
      "Цвет: чёрный.",
      "Объём: 30–40 литров.",
    ],
  },
  {
    order: true,
    id: 98798327330,
    title: "Антифог",
    img: "scd-anti-fog-.png",
    desc: "SCD SUBEA",
    category: "mask",
    price: 38,
    column: [
      "Этот гель снижает образование запотевания внутри маски.",
      "НЕ ПОДХОДИТ для использования с коррекционными очками.",
    ],
  },
  // {
  //   order: true,
  //   id: 100001679,
  //   title: "Сап-борд",
  //   img: "729607464.png",
  //   desc: "Magnum pro light",
  //   category: "supboard",
  //   price: 750,
  //   shortly: "КОМПЛЕКТАЦИЯ: ",
  //   column: [
  //     "Высота доски: 350см",
  //     "Толщина: 15 см",
  //     "Макс. нагрузка: 200 кг",
  //     "Сап борд двухслойный Magnum PRO light поставляется с полной комплектацией: весло (из прочного пластика, разборное, нетонущее); сумка для хранения и транспортировки борда; страховочный лиш; плавник для улучшенного управления сапбордом; дорожный ремонтный комплект.",
  //   ],
  // },
  {
    order: true,
    id: 10043001679,
    title: "Сап-борд",
    img: "5515.48.40.jpg",
    desc: "Hello Plus blue shark 320",
    category: "supboard",
    price: 820,
    shortly: "КОМПЛЕКТАЦИЯ: ",
    column: [
      " -Водонепроницаемый мешок 5 литров - 1 шт",
      "-1 съемный центральный киль - 1 шт.",
      "-Съемный боковой киль - 2 шт.",
      "Ручной насос высокого давления - 1 шт.",
      "Водонепроницаемый мешок большой емкости из материала 600D - 1 шт",
      "Алюминиевое весло - 1 шт.",
      "1 ключ для ремонта (ключ/материал из ПВХ) - 1 шт.",
      "Водонепроницаемый мешок - 1 шт.",
      "Безопасный ремень - 1 шт.",
      "Ширина:84см",
      "Толщина: 15см",
      "Длина: 350 см",
      "Вес: 9.5 кг",
      "Макс. нагрузка: 145 кг",
    ],
  },

  {
    order: true,
    id: 100045171,
    title: "Сап-борд (жираф)",
    img: "sup6.png",
    desc: "Hello Plus",
    category: "supboard",
    price: 820,
    shortly: "КОМПЛЕКТАЦИЯ: ",
    column: [
      " -Водонепроницаемый мешок 5 литров - 1 шт",
      "-1 съемный центральный киль - 1 шт.",
      "-Съемный боковой киль - 2 шт.",
      "Ручной насос высокого давления - 1 шт.",
      "Водонепроницаемый мешок большой емкости из материала 600D - 1 шт",
      "Алюминиевое весло - 1 шт.",
      "1 ключ для ремонта (ключ/материал из ПВХ) - 1 шт.",
      "Водонепроницаемый мешок - 1 шт.",
      "Безопасный ремень - 1 шт.",
      "Ширина:84см",
      "Толщина: 15см",
      "Длина: 350 см",
      "Вес: 9.5 кг",
      "Макс. нагрузка: 145 кг",
    ],
  },
  {
    order: true,
    id: 10004345171,
    title: "Сап-борд (бело-оранжевый)",
    img: "sup7.jpg",
    desc: "Hello Plus",
    category: "supboard",
    price: 770,
    shortly: "КОМПЛЕКТАЦИЯ: ",
    column: [
      " -Водонепроницаемый мешок 5 литров - 1 шт",
      "-1 съемный центральный киль - 1 шт.",
      "-Съемный боковой киль - 2 шт.",
      "Ручной насос высокого давления - 1 шт.",
      "Водонепроницаемый мешок большой емкости из материала 600D - 1 шт",
      "Алюминиевое весло - 1 шт.",
      "1 ключ для ремонта (ключ/материал из ПВХ) - 1 шт.",
      "Водонепроницаемый мешок - 1 шт.",
      "Безопасный ремень - 1 шт.",
      "Ширина:84см",
      "Толщина: 15см",
      "Длина: 350 см",
      "Вес: 9.5 кг",
      "Макс. нагрузка: 145 кг",
    ],
  },
  // {
  // order:true,//
  // id: 1400322045171,
  //   title: "Сап-борд ",
  //   img: "4215.52.33.jpg",
  //   desc: "Hello Plus black&blue",
  //   category: "supboard",
  //   price: 770,
  //   shortly: "КОМПЛЕКТАЦИЯ: ",
  //   column: [
  //     " -Водонепроницаемый мешок 5 литров - 1 шт",
  //     "-1 съемный центральный киль - 1 шт.",
  //     "-Съемный боковой киль - 2 шт.",
  //     "Ручной насос высокого давления - 1 шт.",
  //     "Водонепроницаемый мешок большой емкости из материала 600D - 1 шт",
  //     "Алюминиевое весло - 1 шт.",
  //     "1 ключ для ремонта (ключ/материал из ПВХ) - 1 шт.",
  //     "Водонепроницаемый мешок - 1 шт.",
  //     "Безопасный ремень - 1 шт.",
  //     "Ширина:84см",
  //     "Толщина: 15см",
  //     "Длина: 350 см",
  //     "Вес: 9.5 кг",
  //     "Макс. нагрузка: 145 кг",
  //   ],
  // },
  {
    order: true,
    id: 1400322045171,
    title: "Сап-борд ",
    img: "4215.52.33.jpg",
    desc: "Hello Plus black&blue",
    category: "supboard",
    price: 770,
    shortly: "КОМПЛЕКТАЦИЯ: ",
    column: [
      " -Водонепроницаемый мешок 5 литров - 1 шт",
      "-1 съемный центральный киль - 1 шт.",
      "-Съемный боковой киль - 2 шт.",
      "Ручной насос высокого давления - 1 шт.",
      "Водонепроницаемый мешок большой емкости из материала 600D - 1 шт",
      "Алюминиевое весло - 1 шт.",
      "1 ключ для ремонта (ключ/материал из ПВХ) - 1 шт.",
      "Водонепроницаемый мешок - 1 шт.",
      "Безопасный ремень - 1 шт.",
      "Ширина:84см",
      "Толщина: 15см",
      "Длина: 350 см",
      "Вес: 9.5 кг",
      "Макс. нагрузка: 145 кг",
    ],
  },
  {
    order: true,
    id: 1003220451714,
    title: "Сап-борд ",
    img: "IMG_3451.png",
    desc: "для плавания, дайвинга",
    category: "supboard",
    price: 150,
    shortly: "",
    column: [
      "Надувной мини-сапборд для плавания, дайвинга и снорклинга.",
      "Идеален для буксировки за лодкой, водным скутером или самостоятельных тренировок в воде.",
      "Прочная надувная конструкция из высококачественного ПВХ.",
      "Две удобные усиленные ручки для надёжного захвата.",
      "Нескользящая поверхность для безопасного удержания.",
      "Яркий цвет (жёлто-красный) — хорошо виден на воде, повышает безопасность.",
      "Фронтальное крепление для буксировочного троса.",
      "Лёгкий и портативный — легко накачивается и транспортируется.",
    ],
  },

  {
    order: true,
    id: 3092436598730,
    title: "Силиковая шапка",
    img: "silicone-swim-cap.png",
    desc: " NABAIJI ",
    category: "hat",
    price: 25,
    column: [
      "Превосходная устойчивость, идеально подходит для интенсивных, продвинутых или профессиональных пловцов.",
      "Эластичный и мягкий силикон облегчает надевание.",
    ],
  },
  {
    order: true,
    id: 3092438798730,
    title: "Тканевая шапочка",
    img: "mesh-swim-cap-plain-fabric-pink-nabaiji-8277368.jpg",
    desc: " NABAIJI",
    category: "hat",
    price: 15,
    column: [
      "Эластичная и лёгкая ткань шапочки обеспечивает простоту надевания.",
      "Хорошая фиксация",
    ],
  },
  {
    order: true,
    id: 3092434879832730,
    title: "Силиковая шапка NABAIJI",
    img: "mesh-swim-cap-printed-fabric-size.png",
    desc: "(ромашки, розово-бежевая, серая зебра, синяя)",
    category: "hat",
    price: 32,
    column: [
      "Эластичная и лёгкая ткань шапочки облегчает её надевание.",
      "Хорошо держится на голове",
    ],
  },
  {
    order: true,
    id: 3092438798327330,
    title: "Тканевая детская шапочка NABAIJI",
    img: "mesh-swimming-cap-plain-fabric.png",
    desc: "(розовая, синяя, черная)",
    category: "hat",
    price: 18,
    column: [
      "Эластичная и лёгкая ткань шапочки облегчает её надевание.",
      "Хорошо держится на голове",
    ],
  },
  {
    order: true,
    id: 9879832733044,
    title: "Силиковая шапочка",
    img: "picture999.png",
    desc: "(салатовая, голубая, синяя)",
    category: "hat",
    price: 35,
    column: [
      "Эластичная и лёгкая ткань шапочки облегчает её надевание.",
      "Хорошо держится на голове",
    ],
  },

  {
    order: true,
    id: 9879832734330,
    title: "Ласты",
    img: "picture8989.png",
    desc: "SUBEA FF 100 ",
    category: "flippers",
    price: 85,
    column: [
      "Мощность, необходимая для передвижения по поверхности воды.",
      "Короткий ласт с достаточно жёстким лопастем для ускорения.",
      "Идеальный короткий ласт для удобной транспортировки.",
      "Калоша из мягкого материала, который растягивается и точно подстраивается под стопу.",
      "Короткий ласт с углом 23° для облегчённого входа в воду.",
    ],
  },
  {
    order: true,
    id: 987983273433035,
    title: "Ласты регулируемые",
    img: "a89a-248e7004f0a1.webp",
    desc: "с открытой пяткой S/М, L/XL",
    category: "flippers",
    price: 90,
    column: [
      "Регулируемые ласты с открытой пяткой для снорклинга, плавания и дайвинга.",
      "Подходят для взрослых мужчин и женщин, размеры: S/M и L/XL.",
      "Размеры ЕС: S/M (38–42), L/XL (42,5–47).",
      "Регулируемые ремни с быстросъёмными пряжками — легко надевать и снимать.",
      "Открытый носок и специальная форма снижают сопротивление воды и повышают комфорт.",
      "Можно использовать с водными носками и обувью.",
      "В комплекте сетчатая сумка для переноски и пластиковые вставки для сохранения формы.",
      "Лёгкие и удобные для поездок и путешествий.",
      "Материал: износостойкий пластик и резина.",
    ],
  },
  {
    order: true,
    id: 10032204517145,
    title: "Весло черное",
    img: "sup_veslo_allyuminij_gladiator_lt.webp",
    desc: "Hello Plus",
    category: "oar",
    price: 75,
    shortly: "",
    column: [],
  },
  {
    order: true,
    id: 100322045171455,
    title: "Весло оранжевое",
    img: "wf19.47.13.jpg",
    desc: "Hello Plus",
    category: "oar",
    price: 85,
    shortly: "",
    column: ["170 - 210 см"],
  },
  {
    order: true,
    id: 1003220451714554,
    title: "Весло KOETSU",
    img: "3419.52.13.jpg",
    desc: "210 см, 870 гр",
    category: "oar",
    price: 85,
    shortly: "",
    column: [
      "Палки KOETSU из прочного алюминиевого сплава для серфинга и SUP-сёрфинга.",
      "3-секционный телескопический дизайн — регулируемая длина под разный рост и стиль катания.",
      "Прочный и лёгкий алюминиевый сплав — долговечность и комфорт при использовании.",
      "Несколько вариантов удержания для удобства во время катания.",
      "Идеальны для балансировки, гребли и обучения на доске.",
      "Яркий цветной дизайн — стильный внешний вид и хорошая видимость на воде.",
      "Аксессуар для серфинга, SUP, падлбординга и водных видов спорта.",
    ],
  },
  {
    order: true,
    id: 10203220451714554,
    title: "Весло ITIWIT",
    img: "6685964327.jpg",
    desc: "170/220 см, 960 гр",
    category: "oar",
    price: 160,
    shortly: "",
    column: [],
  },
  {
    order: true,
    id: 1034434301679,
    title: "Плавник Slide-in",
    img: "73684021.png",
    desc: "Standart",
    category: "fin",
    price: 50,
    column: [],
  },
  {
    order: true,
    id: 10004343016799,
    title: "Плавник Slide-in",
    img: "6dfe3692-d029-4c1e-b416-81a82232afad.webp",
    desc: "14 х 12 см (маленький)",
    category: "fin",
    price: 37,
    column: [
      "съёмный плавник для SUP и серфинга — вставной нейлоновый плавник с защёлкивающимся креплением.",
      "Обеспечивает устойчивость и контроль для досок и лодок.",
    ],
  },
  {
    order: true,
    id: 1000434301679,
    title: "Плавник SLIDE IN KOETSU",
    img: "4320.12.06.jpg",
    desc: "15,5 х 22 см (большой)",
    category: "fin",
    price: 50,
    column: [],
  },
  {
    order: true,
    id: 10004343016795,
    title: "Плавник US BOX",
    img: "736c40c6-26fb-44bc-a974.png",
    desc: "15,5 х 20,5 см (большой)",
    category: "fin",
    price: 58,
    column: [],
  },
  {
    order: true,
    id: 1000434301679539,
    title: "Фиксатор ФИНА | ПЛАВНИКА ",
    img: "fin.webp",
    desc: "крепление",
    category: "fin",
    price: 10,
    column: [
      "Зажимы для крепления финна (хвостового руля) на серфборде и SUP-доске.",
      "Подходят для больших скользящих финнов и съёмных диффузоров.",
      "Изготовлены из прочного и долговечного ПВХ.",
      "Обеспечивают надёжную фиксацию финна во время катания.",
      "Удобны в установке и съёме — позволяют быстро менять или снимать фин.",
      "Совместимы с различными моделями SUP и серфбордов.",
    ],
  },
  {
    order: true,
    id: 100043430167953,
    title: "Винт (крепление) плавника",
    img: "7abaa3e6-902e-401d-a2df-deb194aba48c.webp",
    desc: "US BOX ",
    category: "fin",
    price: 15,
    column: [
      "Изготовлены из прочной нержавеющей стали.",
      "Универсальный размер — подходят для большинства серфбордов и SUP-досок.",
      "Обеспечивают надёжную фиксацию и стабильность крепления финнов.",
      "Устойчивы к коррозии и воздействию солёной воды.",
      "Идеальны для серфинга, SUP и других водных видов спорта.",
    ],
  },
  {
    order: true,
    id: 144343016795347,
    title: "Жилет спасательный",
    img: "Most-Popular-EPE-Foam-Life-Jacket-Full-Size-for-Adult-and-Children.avif",
    desc: "Hello Plus взрослый ",
    category: "vest",
    price: 65,
    column: [
      "Наполнитель жилета- пена",
      "Внешний материал жилета- оксфорд",
      "Для максимального комфорта, жилет имеет стяжки, благодаря которым можно регулировать размер",
    ],
  },
  {
    order: true,
    id: 10400434301679534,
    title: "Жилет спасательный",
    img: "Most-Popular-EPE-Foam-Life-Jacket-Full-Size-for-Adult-and-Children.avif",
    desc: "Hello Plus детский",
    category: "vest",
    price: 55,
    column: [
      "Наполнитель жилета- пена",
      "Внешний материал жилета- оксфорд",
      "Для максимального комфорта, жилет имеет стяжки, благодаря которым можно регулировать размер",
    ],
  },
  {
    order: true,
    id: 140090434301679534,
    title: "Жилет для водных видов спорта",
    img: "IMG_0666.JPG",
    desc: "и сапа",
    category: "vest",
    price: 99,
    column: [
      "Наполнитель жилета- пена",
      "Внешний материал жилета- оксфорд",
      "Для максимального комфорта, жилет имеет стяжки, благодаря которым можно регулировать размер",
    ],
  },
  {
    order: true,
    id: 1400904343016795344,
    title: "Страховочный лиш",
    img: "strahovochnyj-lish-coil-leash-8-7mm.webp",
    desc: "Hello Plus для SUP борда ",
    category: "sup_accessories",
    price: 49,
    column: [],
  },
  {
    order: true,
    id: 140090434301679534459,
    title: "Насос двойной с датчиком",
    img: "IMG_4182.JPG",
    desc: "Hello Plus",
    category: "sup_accessories",
    price: 85,
    column: [],
  },
  {
    order: true,
    id: 14009043430167953445,
    title: "Кресло - стул тканевый",
    img: "WhatsApp_Image.png",
    desc: "для Sup",
    category: "sup_accessories",
    price: 150,
    column: [],
  },
  {
    order: true,
    id: 140092343430167953445,
    title: "Сидение надувное",
    img: "IMG_4187.JPG",
    desc: "для Sup",
    category: "sup_accessories",
    price: 150,
    column: [],
  },
  {
    order: true,
    id: 140092343430167953445,
    title: "Держатель сапборда",
    img: "47c8fce6-3be0-4866-9e7b-c9a0b95ddeeb.webp",
    desc: "для напитков и смартфона ",
    category: "sup_accessories",
    price: 25,
    column: [],
  },
  {
    order: true,
    id: 10864167953445,
    title: "Парус",
    img: "IMG_20230905_00233.png",
    desc: "для SUP борда",
    category: "sup_accessories",
    price: 35,
    column: [],
  },
  {
    order: true,
    id: 142304300146,
    title: "Гермопакет для телефона",
    img: "ci4aqul40v.png",
    desc: "плавающий",
    category: "hermo",
    price: 15,
    column: [
      "Высота: 170 мм",
      "Ширина: 100 мм",
      "Изделие подходит для абсолютного большинства моделей смартфонов",
      "Кроме телефона, в него можно вложить деньги, украшения и прочие ценные вещи небольшого размера",
    ],
  },
  {
    order: true,
    id: 14304300146,
    title: "Гермопакет для телефона",
    img: "22.16.11.jpg",
    desc: "плавающий",
    category: "hermo",
    price: 12,
    column: [
      "Изделие подходит для абсолютного большинства моделей смартфонов",
      "Кроме телефона, в него можно вложить деньги, украшения и прочие ценные вещи небольшого размера",
    ],
  },
  {
    id: 1000146,
    title: "Гермопакет для телефона",
    img: "23.11.48.jpg",
    desc: "плавающий",
    category: "hermo",
    order: false,
    price: 24,
    column: [
      "Водонепроницаемость до 2 метров, в течение 30 минут при закрытии",
      "Cтандарт IPX8 / легкая и быстрая застежка-молния",
      "Регулируемая веревка для переноски это позволяет использовать сенсорные функции за пределами воды",
      "Размеры корпуса ширина 110 мм / высота 210 мм / толщина 8.5 мм",
      "Вес: 40 г",
      "Максимальный размер телефона: ширина 90 мм / высота 160 мм.",
    ],
  },
  {
    id: 104300146,
    title: "Гермопакет для телефона",
    img: "s-l1600.png",
    desc: "защита телефона",
    category: "hermo",
    price: 19,
    order: false,
    column: [
      "Водонепроницаемость до 2 метров, в течение 30 минут при закрытии",
      "Регулируемая веревка для переноски это позволяет использовать сенсорные функции за пределами воды",
      "Размеры корпуса ширина 110 мм / высота 210 мм / толщина 8.5 мм",
      "Вес: 40 г",
      "Максимальный размер телефона: ширина 90 мм / высота 160 мм.",
    ],
  },
  {
    order: true,
    id: 1043003146,
    title: "Гермомешок",
    img: "IMG_8530.JPG",
    desc: " HelloPlus 10L",
    category: "hermo",
    price: 59,
    column: [
      "Гермомешок (гермобаул) подходит как для активного отдыха (рыбалка, сплав), так и для хранения и транспортировки вещей и снаряжения.",
      'Мешок имеет цилиндрическую форму с круглым дном и оснащен застежкой типа "фастекс". Верхний край мешка закручивается вплотную вокруг вшитой стропы-планки на нужное количество оборотов, подгибается с двух сторон и застегивается на две защелки. Переноска мешка осуществляется за получившуюся ручку-петлю.',
    ],
  },
  {
    order: true,
    id: 100014865,
    title: "Гермомешок нетонующий",
    img: "8fb71243600589af2ec1.png",
    desc: "OceanPac 2L",
    category: "hermo",
    price: 25,
    column: [
      "Объем 2 литра",
      "Вместимость и практичность — подходит для хранения вещей во время плавания, рыбалки, походов и других активностей.",
      "Непромокаемый материал — изготовлена из прочного ПВХ, надежно защищает содержимое от воды и влаги.",
      "Удобный тканевый ремешок — комфортно носить на плече или через плечо.",
      "Идеальна для спорта и отдыха — универсальный выбор для пляжа, лодки, кемпинга.",
      "Надежность и долговечность — прочная конструкция и износостойкие материалы.",
    ],
  },
  {
    order: true,
    id: 1000143286555,
    title: "Гермомешок нетонующий",
    img: "cebea8e02d1ff88a8.png",
    desc: "OceanPac 5L",
    category: "hermo",
    price: 35,
    column: [
      "Объем 5 литра",
      "Вместимость и практичность — подходит для хранения вещей во время плавания, рыбалки, походов и других активностей.",
      "Непромокаемый материал — изготовлена из прочного ПВХ, надежно защищает содержимое от воды и влаги.",
      "Удобный тканевый ремешок — комфортно носить на плече или через плечо.",
      "Идеальна для спорта и отдыха — универсальный выбор для пляжа, лодки, кемпинга.",
      "Надежность и долговечность — прочная конструкция и износостойкие материалы.",
    ],
  },
  {
    order: true,
    id: 10001432865456,
    title: "Гермомешок нетонующий",
    img: "50782c9bb6af9de7282.png",
    desc: "OceanPac 10L",
    category: "hermo",
    price: 47,
    column: [
      "Объем 10 литра",
      "Вместимость и практичность — подходит для хранения вещей во время плавания, рыбалки, походов и других активностей.",
      "Непромокаемый материал — изготовлена из прочного ПВХ, надежно защищает содержимое от воды и влаги.",
      "Удобный тканевый ремешок — комфортно носить на плече или через плечо.",
      "Идеальна для спорта и отдыха — универсальный выбор для пляжа, лодки, кемпинга.",
      "Надежность и долговечность — прочная конструкция и износостойкие материалы.",
    ],
  },
  {
    order: true,
    id: 100014328654564,
    title: "Гермомешок нетонующий",
    img: "3761a8a8fb85c00fa72.png",
    desc: "OceanPac 20L",
    category: "hermo",
    price: 70,
    column: [
      "Объем 20 литра",
      "Вместимость и практичность — подходит для хранения вещей во время плавания, рыбалки, походов и других активностей.",
      "Непромокаемый материал — изготовлена из прочного ПВХ, надежно защищает содержимое от воды и влаги.",
      "Удобный тканевый ремешок — комфортно носить на плече или через плечо.",
      "Идеальна для спорта и отдыха — универсальный выбор для пляжа, лодки, кемпинга.",
      "Надежность и долговечность — прочная конструкция и износостойкие материалы.",
    ],
  },

  {
    id: 11000147,
    title: "ВОДОНЕПРОНИЦАЕМАЯ СУМКА",
    img: "su-sizdirmaz-silindir-canta-10l-turuncu-2.jpg",
    desc: "ГЕРМОМЕШОК 10 Л ITIWT",
    category: "hermo",
    order: false,
    price: 79,
    column: [
      "Новая двойная полиэфирная ткань с ПВХ-покрытием для большей износостойкости",
      "Есть ручка для удобной переноски в качестве рюкзака",
      "Стандарт IPX4: устойчив к брызгам и кратковременному погружению, что делает ваши электронные устройства безопасными и надежными",
      "Однако перед тем, как поместить их в эту сумку, рекомендуется обеспечить дополнительную защиту, поместив телефоны в водонепроницаемые чехлы",
      "Размеры закрытой сумки: высота 43 см, диаметр 18 см.",
      "Oбъем использования 10 л",
      "Bес пустого составляет 315 г",
      "Основная ткань состоит из 60% полиэстера и 40% полиуретанового термогланца.",
    ],
  },
  {
    order: true,
    id: 1000147,
    title: "ВОДОНЕПРОНИЦАЕМАЯ СУМКА",
    img: "su-sizdirmaz-silindir-canta-30l-turuncu-3.jpg",
    desc: "ГЕРМОМЕШОК 30 Л ITIWT",
    category: "hermo",
    price: 109,
    column: [
      "Новая двойная полиэфирная ткань с ПВХ-покрытием для большей износостойкости",
      "Есть ручка для удобной переноски в качестве рюкзака",
      "Стандарт IPX4: устойчив к брызгам и кратковременному погружению, что делает ваши электронные устройства безопасными и надежными",
      "Однако перед тем, как поместить их в эту сумку, рекомендуется обеспечить дополнительную защиту, поместив телефоны в водонепроницаемые чехлы",
      "Размеры закрытой сумки: высота 63 см, диаметр 26 см.",
      "Oбъем использования 30 л",
      "Bес пустого составляет 655 г",
      "Основная ткань состоит из 60% полиэстера и 40% полиуретанового термогланца.",
    ],
  },
  {
    order: true,
    id: 1000148,
    title: "ВОДОНЕПРОНИЦАЕМЫЙ КОМПРЕССИОННЫЙ МЕШОК",
    img: "trekking-su-gecirmez-sikistirma-kilif-25-litre.jpg",
    desc: "25L FORCIAZ",
    category: "hermo",
    price: 45,
    column: [
      "Емкость: 25 литров.",
      "Вес: 200 грамм.",
      "Размеры: 78 см x 40 см.",
      "Чехол полностью водонепроницаемый при закрытии.",
      "Основная ткань состоит из 100% полиэтилентерефталатного покрытия.",
      "Этот чехол предназначен для того, чтобы вы могли разместить свои вещи, безопасно защитить их и носить в рюкзаке. Он защищает и хранит ваши вещи от влаги, дождя и пыли.",
    ],
  },
  {
    order: true,
    id: 1043001489,
    title: "Обувь для пляжа",
    img: "f868cd79-546c-4990-957f-e60263f80295.webp",
    desc: "39,41,,44,46",
    category: "shoes",
    price: 74,
    column: [],
  },
  {
    order: true,
    id: 10430014845,
    title: "Быстросохнующая обувь ",
    img: "7264ca64-b562-40bb-a4dc-59f5b7a643f1.webp",
    desc: "XS34-35, S36-37, M38-39",
    category: "shoes",
    price: 13,
    column: [],
  },
  {
    order: true,
    id: 134304340054243234,
    title: "Коврик",
    titleEng: "MAT",
    img: "folga-paraloni.webp",
    desc: "пляжный фольга",
    descEng: "",
    category: "beach",
    price: 16,
    column: ["180*60*1 см"],
    columnEng: [""],
  },
  {
    order: true,
    id: 90382921391214,
    title: "Зонт пляжный",
    img: "6076743152.jpg",
    desc: "красный, синий",
    category: "beach",
    price: 35,
    column: [],
  },
  {
    order: true,
    id: 9038292139121489,
    title: "Зонт пляжный",
    img: "47046567365643.jpeg",
    desc: "XL",
    category: "beach",
    price: 75,
    column: ["Зонт 210 см высота, 175 см ширина"],
  },
];
